import { PartnerBucketGroupPrice } from "../../../../interfaces/partnerDeal.interface";
import { IOnlinePurchPriceProfile } from "../../../../interfaces/partner.interface";

// A deal's online range is chosen independently of in-person, from the partner's
// own online profiles. A profile whitelisted to specific KVK numbers is only
// offered to those merchants; an empty/absent whitelist is offered to all.
export const filterAllowedOnlineProfiles = (
  profiles: IOnlinePurchPriceProfile[] | undefined,
  businessRegistrationNumber: string | undefined
): IOnlinePurchPriceProfile[] =>
  (profiles ?? []).filter((profile) => {
    if (!profile?.whitelist || profile.whitelist.length === 0) return true;
    return profile.whitelist.includes(businessRegistrationNumber || "");
  });

export const selectOnlineProfile = (
  allowed: IOnlinePurchPriceProfile[],
  selectedId: string | undefined
): IOnlinePurchPriceProfile | undefined =>
  allowed.find((profile) => profile._id === selectedId) ||
  allowed.find((profile) => profile.name === "default") ||
  allowed[0];

// Klearly floor + max come from the selected online profile's band (its bucket
// value is the floor); the partner-default column stays the partner's online
// rate. Falls back to the partner default / hardcoded defaults when the partner
// has no online profiles.
export type OnlineBand = PartnerBucketGroupPrice & { min: number; max: number };

export const resolveOnlineBand = (
  profileBucket: PartnerBucketGroupPrice | undefined,
  partnerDefault: PartnerBucketGroupPrice,
  fallbackFloor: number,
  fallbackMax: number
): OnlineBand => ({
  value: partnerDefault.value,
  valueType: profileBucket?.valueType || partnerDefault.valueType,
  // `||` not `??`: 0 is how an online bucket spells "floor/max not set" (persisted
  // as { value: 0 } when only the partner default is set), so fall through past it.
  min: profileBucket?.value || partnerDefault.min || fallbackFloor,
  max: profileBucket?.max || partnerDefault.max || fallbackMax,
});
